export default __webpack_public_path__ + "static/media/20.669b2f44.png";